// extracted by mini-css-extract-plugin
export default {"subText":"Checkbox_subText__0Nsmz"};